<template>
  <div class="flex justify-end headerRight" style="min-width: 150px;flex: 1;height: 100%;padding-right: 27px;">
    <div v-if="showDeptSwitch" class="dept-switch">
      <span class="dept-label">当前部门：</span>
      <el-select
        v-model="selectedDeptId"
        placeholder="请选择部门"
        filterable
        size="small"
        :loading="switchLoading"
        style="width: 220px;"
        @change="handleDeptChange"
      >
        <el-option
          v-for="item in sysDeptList"
          :key="item.id"
          :label="item.deptName"
          :value="item.id"
        />
      </el-select>
    </div>
    <div class="userInfo">
      <span @click="handleCommand('userCenter')">
        <img v-if="$store.state.user.currentInfoUserData.avatar"
          :src="imageUrlprefix + $store.state.user.currentInfoUserData.avatar" alt="">
        <img v-else src="@/assets/userIcon.png" alt="">{{ $store.state.user.currentInfoUserData.name }}, 欢迎登录!
      </span>
      <span></span>
      <span class="logout" style="padding-left: 32px;" @click="logout">登出</span>
      <!-- <i class="el-icon-caret-bottom el-icon--right text-dark"></i> -->
    </div>
    <!-- <el-dropdown-menu slot="dropdown" :hide-on-click="false">
        <el-dropdown-item command="userCenter">个人中心</el-dropdown-item>
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { remove } from '@/utils/sessionStorage'
import defaultAvater from "@/assets/defaultAvater.png"
import { switchDept } from '@/api/sys/user'

export default {
  name: "UserOpt",
  computed: {
    ...mapGetters([
      'name',
      'phone',
    ]),
    /** 超管不展示部门切换 */
    showDeptSwitch() {
      const userId = this.$store.state.user.userData.userId
      return userId != -1 && userId !== '-1'
    },
    sysDeptList() {
      return this.$store.state.user.currentInfoUserData.sysDeptList || []
    }
  },
  data() {
    return {
      defaultAvater,
      selectedDeptId: '',
      switchLoading: false,
      /** 切换失败时用于还原选中项 */
      lastDeptId: ''
    }
  },
  watch: {
    '$store.state.user.currentDeptId': {
      immediate: true,
      handler(val) {
        this.selectedDeptId = val || ''
        this.lastDeptId = val || ''
      }
    }
  },
  methods: {
    async handleDeptChange(deptId) {
      if (!deptId || deptId === this.lastDeptId) return
      const dept = this.sysDeptList.find(item => item.id === deptId)
      const deptName = dept ? dept.deptName : ''
      try {
        await this.$confirm(
          deptName ? `是否切换到「${deptName}」？` : '是否切换部门？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
      } catch (e) {
        // 取消切换，还原选中项
        this.selectedDeptId = this.lastDeptId
        return
      }
      this.switchLoading = true
      try {
        const res = await switchDept({ deptId })
        if (!res || res.code !== 200) {
          this.selectedDeptId = this.lastDeptId
          return
        }
        await this.$store.dispatch('GetInfo')
        this.$store.commit('SET_CURRENT_DEPT_ID', deptId)
        this.lastDeptId = deptId
        this.$message.success('部门切换成功')
        // 刷新当前页，让列表按新部门重新请求
        this.$router.go(0)
      } catch (e) {
        this.selectedDeptId = this.lastDeptId
      } finally {
        this.switchLoading = false
      }
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push("/login")
        localStorage.setItem('isLogout', true)//是否退出登录 true是 false否
        this.$message.success('退出登录成功！')
      })
    },
    handleCommand(command) {
      if (command === "userCenter") {
        this.$router.push("/user/center")
      }
      if (command === "logout") {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.push("/login")
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.headerRight {
  // background-image: url("~@/assets/headerbg2.png");
  background-size: 230px 64px;
  background-repeat: no-repeat;
  background-position: right bottom;
  align-items: center;
  gap: 16px;
}

.dept-switch {
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 8px;

  .dept-label {
    color: #fff;
    font-size: 14px;
    white-space: nowrap;
    margin-right: 8px;
  }
}

.userInfo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  cursor: pointer;

  img {
    display: inline-block;
    border-radius: 50%;
  }

  span {
    display: inline-block;
    display: flex;
    align-items: center;

    >img {
      width: 33px;
      height: 35px;
      margin-right: 12px;
    }
  }

  span:nth-child(2) {
    width: 1px;
    height: 14px;
    background-color: rgba(0, 0, 0, 0.2);
    margin: 0px 16px;
  }
  span:last-child {
    color: #FF4958FF;
  }

  .logout {
    position: relative;
    color: #ff4958ff;
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      width: 24px;
      height: 24px;
      transform: translateY(-50%);
      background-image: url("~@/assets/off.png");
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }
}
</style>
